import { system } from './system.js';
import { models } from './models.js';
import { api } from './api.js';
import { shop } from './shop.js';

function getProvider($element) {
    if (!$element || !$element.length) { return ""; }
    var provider = $element.data('purchaseProvider');
    return provider;
}

//#region OrderIndex

function OrderIndexViewModel(config) {
    this.order = new models.Order(config.order);
    this.isFormVisible = ko.observable(false);
    this.priceLabels = {
        order: ko.computed(function () {
            if (this.order.totalDue() <= 0) {
                return "FREE";
            }
            return shop.formatPrice(this.order.totalDue(), this.order.currency.id(), this.order.currency.symbol());
        }, this),
        product: ko.computed(function () {
            return shop.formatPrice(this.order.orderDetail.productPrice(), this.order.currency.id(), this.order.currency.symbol());
        }, this),
        discount: ko.computed(function () {
            return shop.formatPrice(this.order.discount.amount(), this.order.currency.id(), this.order.currency.symbol());
        }, this)
    };
    this.message = {
        content: ko.observable(null),
        type: ko.observable(system.messageTypes.empty),
    };
    this.message.style = ko.computed(function () {
        var type = this.message.type();
        return 'alert-' + type;
    }, this);
    this.hasErrors = ko.computed(function () {
        var result = this.message.type() === system.messageTypes.danger;
        return result;
    }, this);
    this.hasMessage = ko.computed(function () {
        var content = this.message.content();
        return typeof content !== "undefined" && content !== null && content !== "";
    }, this);
}

OrderIndexViewModel.prototype.toggleForm = function () {
    this.isFormVisible(!this.isFormVisible());
};

OrderIndexViewModel.prototype.resetForm = function () {
    this.order.discount.code(null);
    this.isFormVisible(false);
};

OrderIndexViewModel.prototype.claimDiscount = function () {

    var that = this,
        customerId = that.order.customerId(),
        orderId = that.order.id();

    // remove spaces
    that.order.discount.code(that.order.discount.code().trim());

    var discountCode = that.order.discount.code();

    console.group("Starting claim discount flow");

    if (!discountCode) {
        that.setMessage("Cannot claim an empty code", system.messageTypes.danger);
        console.groupEnd();
        return;
    }

    shop.claimDiscount(customerId, orderId, discountCode)
        .done(function (result) {
            console.log("claim discount succeeded", result);
            if (!result.isValid) { that.setMessage("This discount code is not valid", system.messageTypes.danger); return; }
            if (!result.isApplied) { that.setMessage("Unable to apply this discount code", system.messageTypes.danger); return; }
            that.order.discount.name(result.discountName);
            that.order.discount.amount(result.discountAmount);
            that.order.totalDue(result.newPrice);
            that.resetForm();
            that.setMessage("Discount applied", system.messageTypes.info);
        })
        .fail(function (result) {
            console.warn("claim discount failed", result);
            that.setMessage("Unable to claim your discount", system.messageTypes.danger);
        })
        .always(function () {
            console.groupEnd();
        });
};

OrderIndexViewModel.prototype.unclaimDiscount = function () {
    var that = this,
        customerId = that.order.customerId(),
        orderId = that.order.id();

    console.group("Starting unclaim discount flow");

    shop.unclaimDiscount(customerId, orderId)
        .done(function (result) {
            console.log("unclaim discount succeeded", result);
            that.order.discount.name(null);
            that.order.discount.amount(0);
            that.order.totalDue(result.newPrice);
            that.resetForm();
            that.setMessage("Discount removed", system.messageTypes.info);
        })
        .fail(function (result) {
            console.warn("unclaim discount failed", result);
            that.setMessage("A server error occured while removing your discount", system.messageTypes.danger);
        })
        .always(function () {
            console.groupEnd();
        });

    console.groupEnd();
};

OrderIndexViewModel.prototype.setMessage = function (content, type) {
    if (!content) {
        this.message.content(null);
        this.message.type(null);
    } else {
        this.message.content(content);
        this.message.type(type);
    }
};

OrderIndexViewModel.prototype.purchase = function (vm, event) {
    var that = this,
        $target = $(event.originalEvent.target),
        provider = getProvider($target),
        orderId = that.order.id(),
        productId = that.order.orderDetail.productId(),
        productUrl = that.order.orderDetail.productUrl(),
        extraData = that.order.extraData();

    console.group("Starting Purchase flow with provider : " + provider);

    shop.purchase(provider, orderId, productId, productUrl)
        .done(function (result) {
            console.log('Payment succeeded', result);
            window.location = api.resources.deliver + "/" + orderId;

        }).fail(function () {
            console.log('Payment failed or cancelled');
            window.location = api.resources.coatofarmDownload + '/' + extraData;
        }).always(function () {
            console.groupEnd();
        });
};

//#endregion

//#region DownloadIndex
function DownloadIndexViewModel(config) {
    var self = this;
    self.re = /\S+@\S+\.\S+/;
    self.originalEmail = ko.observable(config.email);

    self.id = ko.observable(config.id);
    self.sharedKey = ko.observable(config.sharedKey);
    self.email = ko.observable(config.email);
    self.result = ko.observable("");

    self.downloadRight = ko.observable(0);
    self.setDownloadRight = function (right) {
        self.downloadRight(right);
    }

    self.shieldonly = ko.observable(config.shieldonly);

    self.isEmailValid = ko.computed(function () {
        return self.re.test(self.email());
    });

    self.hasEmailChanged = ko.computed(function () {
        return self.email() !== self.originalEmail();
    });

    self.newsletterSubscribe = ko.observable(config.newsletterSubscribe);
}

DownloadIndexViewModel.prototype.cancel = function (vm, event) {
    var self = this;
    setTimeout(function () {

        self.email(self.originalEmail());
        self.result("");

    }, 2000);
};

DownloadIndexViewModel.prototype.close = function (vm, event) {
    var self = this;
    setTimeout(function () {

        self.result("");
        $("#popup_downloadEmail_success").hide();
        $("#popup_downloadEmail_fail").hide();
        $("#popup_downloadEmail_form").show();

    }, 2000);
};

DownloadIndexViewModel.prototype.updateEmail = function (vm, event) {
    var self = this,
        $target = $(event.target),
        $targetOverlay = $target.prev(".loading-overlay");

    $targetOverlay.show();
    $.ajax({
        type: "POST",
        url: api.resources.changeEmailAjax,
        data: { EmailAddress: self.email() },
        success: function (data) {
            self.result(data);
            if (data === "Email updated") {
                self.originalEmail(self.email());
            }
        },
        error: function (data) {
            self.result(data);
        },
        fail: function (data) {
            self.result(data);
        }
    })
        .always(function () {
            $targetOverlay.hide();
        });;

};

DownloadIndexViewModel.prototype.download = function (vm, event) {
    var self = this,
        $target = $(event.target),
        $targetOverlay = $target.prev(".loading-overlay");

    $targetOverlay.show();
    $("#loading-spinner").show();

    $.ajax({
        type: "GET",
        url: api.resources.coatofarmDownloadEmail,
        data: { email: self.email(), sharedKey: self.sharedKey(), withOrna: !self.shieldonly(), claimedRight: self.downloadRight(), newsletterSubscribe: self.newsletterSubscribe },
        success: function (data) {
            $("#popup_downloadEmail_form").hide("slow");
            $("#popup_downloadEmail_fail").hide("slow");
            $("#popup_downloadEmail_success").show("slow");
        },
        error: function (data) {
            $("#popup_downloadEmail_form").hide("slow");
            $("#popup_downloadEmail_success").hide("slow");
            $("#popup_downloadEmail_fail").show("slow");
        }
    })
        .always(function () {
            $targetOverlay.hide();
            $("#loading-spinner").hide();
        });
};
//#endregion

//#region EditVM
var PollViewModel = function (options) {
    var self = this;

    self.Id = "";

    self.email = ko.observable(options.Email);
    var rexp = /\S+@\S+\.\S+/;

    //self.check = ko.observable(true);
    self.selectedElements = ko.observableArray();

    self.coatOfArmsId = options.coatOfArmsId;
    self.userId = options.userId;

    self.close = function () {
        $("#poll-popup").hide();
    };

    self.confirm = function () {
        //if (self.selectedElements().length > 0 && ((self.email() !== "" && rexp.test(self.email())) || !self.check())) {

        var $form = $("<form></form>");
        $form.append("<input type='hidden' name='coatOfArmsId' value='" + self.coatOfArmsId + "' />");
        $form.append('<input type="hidden" name="userId" value=' + self.userId + ' />');
        $form.append('<input type="hidden" name="email" value=' + self.email() + ' />');
        $form.append('<input type="hidden" name="selectedElements" value=' + self.selectedElements() + ' />');
        $form.append('<input type="hidden" name="id" value=' + self.Id + ' />');

        //$form.submit(function (ev) {
        $.ajax({
            method: "POST",
            url: "/api/poll",
            data: $form.serialize()/*,
                        success: function (data) {
                            //console.log(data);
                        },
                        error: function (data) {
                            //console.log(data);
                        }*/
        });
        //});

        //$form.submit();

        $("#poll-popup").hide();
        //}            
    };


    //self.isEnabled = ko.computed(function () {
    //    return ((self.selectedElements().length > 0) && ((self.email() !== "" && rexp.test(self.email())) || !self.check()));
    //});

    self.select = function (data, event) {
        var $element = $(event.currentTarget);
        var selection = $element.data("selection");
        var elements = self.selectedElements();

        if (elements.indexOf(selection) > -1) {
            elements.splice(elements.indexOf(selection), 1);
            $element.removeClass("selected");
        } else {
            elements.push(selection);
            $element.addClass("selected");
        }

        self.selectedElements(elements);
        //console.log(self.selectedElements());
    };
};
//#endregion


export const viewmodels = {
    OrderIndex: OrderIndexViewModel,
    DownloadIndex: DownloadIndexViewModel,
    Poll: PollViewModel,
};